module.exports = __webpack_public_path__ + "static/media/module2.43ed9565.png";